<template>
    <tr
        class="dt__row"
        :class="{
            'dt__row--active': active,
            'dt__row--highlighted': highlighted
        }"
    >
        <td class="dt__img-row"><img :src="image?.img" /></td>
        <td class="dt__carat-row">{{ carat }}</td>
        <td class="dt__cut-row">{{ cut }}</td>
        <td class="dt__clarity-row">{{ clarity }}</td>
        <td class="dt__color-row">{{ color }}</td>
        <td class="dt__price-row">{{ priceHumanReadable }}</td>
    </tr>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from "vue";
import useDiamondProperties from "@/composables/useDiamondProperties";
import useDiamondShapeImageMap from "@/composables/useDiamondShapeImageMap";
import { Diamond } from "@/api/Diamond";
import { useI18n } from "vue-i18n";
import store from "@/store/store";

export default defineComponent({
    name: "DiamondTableEntry",
    props: {
        diamond: {
            type: Object as PropType<Diamond>,
            required: true
        },
        active: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    setup(props) {
        const diamondShapeImageMap = useDiamondShapeImageMap();

        const { t } = useI18n();

        const image = computed(() => diamondShapeImageMap[props.diamond.shape]);
        const {
            carat,
            cut,
            color,
            shape,
            clarity,
            priceHumanReadable,
            highlighted,
            videoLink
        } = useDiamondProperties(computed(() => props.diamond));

        const cutText = computed(() =>
            cut.value ? t(`diamondProperties.cut.${cut.value}`) : "-"
        );

        const highlightedText = computed(() => t("components.highlighted"));

        function handleShowInfoButton() {
            store.actions.setInfoSelectedDiamond(props.diamond);
            store.actions.setShowInfoModal(true);
        }

        return {
            image,
            carat,
            cut,
            cutText,
            color,
            shape,
            clarity,
            priceHumanReadable,
            highlighted,
            videoLink,
            highlightedText,
            handleShowInfoButton
        };
    }
});
</script>
